interface PanelActionsDeps {
  openLeftPanelTab: (tabName: string) => void;
}

export function initPanelActions(deps: PanelActionsDeps): void {
  const historyBtn = document.getElementById('history-btn') as HTMLButtonElement | null;
  const shortcutsBtn = document.getElementById('shortcuts-btn') as HTMLButtonElement | null;

  shortcutsBtn?.addEventListener('click', () => {
    deps.openLeftPanelTab('hotkeys');
  });

  historyBtn?.addEventListener('click', () => {
    deps.openLeftPanelTab('history');
  });
}
